module.exports = __webpack_public_path__ + "it.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/it.svg
// module id = 622
// module chunks = 0